import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import {
  ErrorDialogComponent,
  ErrorService,
  PopupDialogComponent,
  PopupService,
} from '@upassignations/core';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root',
})
export class ParentService {
  availableModulesValue = [];

  private targetForFileSystem = new BehaviorSubject<string>(null);
  private availableModules = new BehaviorSubject<string[]>([
    'contractAnalysis',
  ]);
  parametersForDocumentAnalysis$ = new BehaviorSubject<{
    resource;
    analysisMethods?;
  }>(null);

  constructor(
    // eslint-disable-next-line no-unused-vars
    private router: Router,
    // eslint-disable-next-line no-unused-vars
    private errorService: ErrorService,
    // eslint-disable-next-line no-unused-vars
    private popupService: PopupService,
    // eslint-disable-next-line no-unused-vars
    private dialog: MatDialog
  ) {
    this.availableModules
      .pipe(
        map((availableModulesValue) => {
          this.availableModulesValue = availableModulesValue;
        })
      )
      .subscribe();
    this.errorService
      .subscribeError()
      .pipe(
        map((isInError) => {
          if (isInError) {
            const initialTop = 1;
            const dialogRef = this.dialog.open(ErrorDialogComponent, {
              width: '30em',
              data: {
                errorCode: this.errorService.getCode(),
                errorMessage: this.errorService.getMessage(),
              },
              disableClose: true,
              hasBackdrop: false,
              position: {
                top: initialTop + 'px', // Set the top position of the dialog
                right: '1px',
              },
              panelClass: [
                'custom-dialog',
                'animate__animated',
                'animate__slideInRight',
              ],
            });

            this.computeAndArrangeNotifications(initialTop, true);

            dialogRef.afterOpened().subscribe(() => {
              setTimeout(() => {
                dialogRef.close();
              }, 15000);
            });
            dialogRef.afterClosed().subscribe(() => {
              this.computeAndArrangeNotifications(initialTop, true);
              this.errorService.clear();
            });
          }
        })
      )
      .subscribe();
    this.popupService
      .subscribeTrigger()
      .pipe(
        map((triggered) => {
          if (triggered) {
            const initialTop = 1;
            const popupActions = this.popupService.getActions();
            const dialogRef = this.dialog.open(PopupDialogComponent, {
              width: popupActions.length ? '800px' : '30em',
              data: {
                type: this.popupService.getType(),
                message: this.popupService.getMessage(),

                actions: popupActions.length ? popupActions : [],
              },
              disableClose: popupActions.length ? true : false, //prevent close by clicking outside dialog when ther are actions to take
              hasBackdrop: popupActions.length ? true : false,
              position: !popupActions.length
                ? {
                    top: initialTop + 'px', // Set the top position of the dialog
                    right: '1px',
                  }
                : {},
              panelClass: !popupActions.length
                ? [
                    'custom-dialog',
                    'animate__animated',
                    'animate__slideInRight',
                  ]
                : [],
            });
            if (!popupActions.length) {
              this.computeAndArrangeNotifications(initialTop, true);

              dialogRef.afterOpened().subscribe(() => {
                setTimeout(() => {
                  dialogRef.close();
                }, 15000);
              });
            }
            dialogRef.afterClosed().subscribe((response) => {
              this.popupService.setChoice(response?.choice);
              this.popupService.clear();
            });
          }
        })
      )
      .subscribe();
  }

  computeAndArrangeNotifications(initialTop, reverseElements): void {
    let existingDialogs = Array.from(
      document.querySelectorAll('.custom-dialog')
    );

    if (reverseElements) {
      existingDialogs = existingDialogs.reverse();
    }

    // Update 'top' value and reverse order in the DOM
    let lastTop;
    existingDialogs.forEach((dialog: HTMLElement, index: number) => {
      if (index === 0) {
        lastTop = initialTop;
      } else {
        lastTop += 110;
      }
      const topValue = lastTop + 'px'; // Adjust the spacing between dialogs as desired
      dialog.style.position = 'fixed';
      dialog.style.top = topValue;
      dialog.style.zIndex = String(existingDialogs.length - index);
    });
  }
}
